import { useState } from 'react';

function ProfileImage() {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<div
			style={{
				width: '200px',
				height: '200px',
				borderRadius: '50%',
				overflow: 'hidden',
				position: 'relative',
				margin: '0 auto',
			}}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<img
				src="/images/sterling.jpg"
				alt="Still"
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					transition: 'opacity 0.3s ease-in-out',
					opacity: isHovered ? 0 : 1,
				}}
			/>
			<img
				src="/images/sterling.gif"
				alt="Animated"
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					transition: 'opacity 0.3s ease-in-out',
					opacity: isHovered ? 1 : 0,
				}}
			/>
		</div>
	)
}

export default ProfileImage;
